module.exports = __webpack_public_path__ + "static/image-8e90e8729a430580ea508f8718a8b038.png";